export default __webpack_public_path__ + "static/media/subjectsBackground.d950fea3.png";